<template>  
    <div class="Searchpop">
      <el-dialog :title="searchData.title"  width="800px" append-to-body :visible.sync="visible"  @close="clearData" :show="show">
          <div class="content_box" ref="key_content" id="key_content"  tabindex="1" @keyup.up="upkey($event)" @keyup.down="downkey($event)"  @keyup.enter="enterkey($event)">
            <div class="content_top">
              <el-input ref="input" v-model="searchText" size="mini" placeholder="输入名称/编号" class="search_input" @keyup.up.native="upkey($event)" @keyup.down.native="downkey($event)"  @keyup.enter.native="enterkey($event)"></el-input>
              <el-checkbox v-model="showLeve" style="margin-left:10px;">显示层级结构</el-checkbox>
              <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
            </div>
            <div class="content_infor_box">
                <div class="tree_sty" id="box">
                    <Tree :treeData="treeData" @clickTree="clickTree" ref="treecomponent"/>
                </div>
                <vxe-table ref="xTable"  class="right"  resizable size="small" border  highlight-hover-row  highlight-current-row :keyboard-config="{isArrow:true}"  :auto-resize="true"  height="auto"
                 :data="tableData" show-overflow show-header-overflow @current-change="currentChangeEvent" @cell-dblclick="dblclick">
                    <vxe-table-column type="index" width="50" align="center" fixed="left" >
                        <template v-slot:header="{ column }">
                            <span v-if="isInner" style="font-size:12px">行号</span>
                            <i  v-if="!isInner" class="el-icon-refresh-left" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
                        </template>
                        <template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
                    </vxe-table-column>
                    <template v-for="(item,index) in tableHeadData">
                        <vxe-table-column :field="item.Key" :title="item.Label" width="60" align="center" v-if="item.Key=='IsDir'"  :key="index">
                            <template v-slot="{row,rowIndex}">
                                <i :class="row.IsDir?'el-icon-folder':'el-icon-tickets'" style="color:#e9cb70;font-size:18px"></i>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column :field="item.Key" :title="item.Label" width="120" align="center" v-else-if="item.Key=='FullName'"  :key="index"></vxe-table-column>
                        <vxe-table-column :field="item.Key" :title="item.Label" width="120" align="center" v-else-if="item.Key=='BaseCode'"  :key="index"></vxe-table-column>
                        <vxe-table-column :field="item.Key" :title="item.Label" width="120" align="center" v-else  :key="index"></vxe-table-column>
                    </template>
                </vxe-table>
            </div>
          <!-- 分页 -->
          <el-pagination
              style="margin:10px auto 0;display: flex;justify-content: center; "
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              @prev-click="prevPage"
              @next-click="nextPage"
              :current-page="currentPage"
              :page-sizes="[10, 20,50,100]"
              :page-size="pageSize"
              layout="total, sizes,prev, pager, next, jumper"
              :total="total"
              ></el-pagination>
          </div>
      </el-dialog>
    </div> 

</template>  

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool";//本地缓存存取

export default {
    data () {  
        return {
            Identify:0,//标志是请求getall接口还是search接口，0：getall，1：search
            // 字段值
            searchText:'',//收索内容
            treeData:[],//树状图数据
            tableData:[],//table表格数据
            tableHeadData:[],//表格表头配置字段

            // 状态值
            isInner: true,//标记表格表头显示icon
            visible: this.show,//是否显示选择弹出框
            showLeve:true,//是否显示层级
            rowIndex:0,//默认表格索引
            ParentId:0,//父级id

            // 分页
            currentPage: 1, //当前页码
            total: 0, //总页数
            pageSize: 10, //每页显示数量
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        searchData:[Object],
    },
    watch: {
        show (){
            this.visible = this.show;
            if (this.visible) {
                this.ParentId = 0;
                this.switchInit(this.showLeve);
                this.$nextTick( () =>{
                    this.$refs.key_content.focus();
                    // this.$refs.input.focus();
                } )
            }
        },
        // 默认选中表格第一行
        tableData:{
            handler:function(newVal,oldVal){
                let that = this;
                if (that.visible&&newVal&&newVal.length>0) {
                    that.rowIndex = 0;//重置索引
                    that.$nextTick( () =>{
                        that.$refs.xTable.setCurrentRow(that.tableData[0]);
                    } )
                }
            },
            deep:true//对象内部的属性监听，也叫深度监听
        },
        //监听显示层级结构
        showLeve(){
            this.switchInit(this.showLeve);
        }
    },
    methods:{
        // 请求树状图数据
        InitTree(){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                Stoped:this.$attrs.pargam.Stoped,//是否数据的状态 0启用 1停用  不传两者都有
                style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
            }
            this.request.post(this.searchData.url1, {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    this.treeData = res.tree;
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 请求table表格数据
        InitTable(typeId){
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                pagesize:this.pageSize,
                pagenum:this.currentPage,
                ParentNo:this.ParentId,
                type:typeId,//type=0查询所有一级数据  type=1查询所有末端数据
                Stoped:this.$attrs.pargam.Stoped,//是否数据的状态 0启用 1停用  不传两者都有
                style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                // KtypeId:this.$attrs.pargam.KtypeId,//仓库ID,KFlag为1才生效
                // BtypeId:this.$attrs.pargam.BtypeId,//客户&供应商ID,KFlag为1才生效
            }
            this.request.post(this.searchData.url2, {jparams:JSON.stringify(params)})
                .then(res => {
                // 接收后端发送回来的数据
                    this.total = res.count;
                    this.tableData = res.data;
                })
                .catch(err => {
                    console.log(err);
            });
        },
        // 单击表格某行
        clickRow(row){
            this.$refs.xTable.setCurrentRow(row.row);
        },
        // 双击表格某行
        dblclick(row){
            let RowData = row.row;
            // let ParentId;
            // console.log('双击某行',RowData)
            switch (this.searchData.classify) {
                case 'Client'://客户/供应商
                        this.ParentId = RowData.BtypeId;
                        break;
                    case 'ClientA'://客户
                        this.ParentId = RowData.BtypeId;
                        break;
                    case 'ClientB'://供应商
                        this.ParentId = RowData.BtypeId;
                        break;
                    case 'Stock'://仓库
                        this.ParentId = RowData.KtypeId;
                        break;
                    case 'Person'://经手人
                        this.ParentId = RowData.EtypeId;
                        break;
                    case 'Department'://部门                        
                        this.ParentId = RowData.DeptId;
                        break;
                    case 'Area'://地区
                        this.ParentId = RowData.AreaId;
                        break;
                    case 'Goods'://商品
                        // this.ParentId = RowData.BtypeId;
                        break;
                    default:
                        break;
            }
            if (RowData.IsDir) {
                this.currentPage = 1;//重置页码
                if (this.showLeve) {
                    this.QueryTable(this.ParentId,0);
                }else{
                    this.QueryTable(this.ParentId,1);
                }
                this.isInner = false;
            }else{
                this.$nextTick(()=>{
                   this.$emit('chooseBack',RowData)
                   this.$emit('update:show', false);
               })
            }
        },
        // 判断是否显示层级结构
        switchInit(isShow){
            if (isShow) {
                if(!this.ParentId){
                    this.InitTable(0);
                }else{
                    this.QueryTable(this.ParentId,0)
                }
            }else{
                if(!this.ParentId){
                    this.InitTable(1);
                }else{
                    this.QueryTable(this.ParentId,1)
                }
            }
        },
        // 点击返回icon
        clickIcon(){
            this.ParentId = 0;//重置ParentId
            this.switchInit(this.showLeve);
            this.isInner = true;//改变表头图标
        },
        // 条件查询table数据
        QueryTable(ParentId,type){
            let params;
            if(this.searchData.classify == 'Person'||this.searchData.classify == 'Department'){
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    pagesize:this.pageSize,
                    pagenum:this.currentPage,
                    Stoped:this.$attrs.pargam.Stoped,//是否启用
                    type:type,//0显示层级结构 1不显示
                    DeptId:ParentId,//部门ID
                    style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                    Keywords:this.searchText,
                }
            }else{
                params = {
                    user_id:tool.getLocal("userid"),
                    session_id:tool.getLocal("sessionid"),
                    pagesize:this.pageSize,
                    pagenum:this.currentPage,
                    Stoped:this.$attrs.pargam.Stoped,//是否启用
                    type:type,//0显示层级结构 1不显示
                    ParentNo:ParentId,//要查找的单位、职员、部门、地区、的父ID
                    style:this.$attrs.pargam.style,//1-供应商,0-客户,2-客户供应商都出来
                    Keywords:this.searchText,
                }
            }
            this.request.post(this.searchData.url3, {jparams:JSON.stringify(params)})
                .then(res => {
                    // 接收后端发送回来的数据
                    this.total = res.count;
                    this.tableData = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 点击收索按钮
        searchClick(){
            let type;
            if (this.showLeve) {
                type = 0;
            }else{
                type = 1;
            }
            this.Identify = 1;//把标志改为1.请求search接口
            let params = {
                user_id:tool.getLocal("userid"),
                session_id:tool.getLocal("sessionid"),
                Keywords:this.searchText,
                pagesize:this.pageSize,
                pagenum:1,
                style:this.$attrs.pargam.style,
                Stoped:this.$attrs.pargam.Stoped,//是否数据的状态 0启用 1停用  不传两者都有
                type:type,//0显示层级结构 1不显示
            }
            this.request.post(this.searchData.url3, {jparams:JSON.stringify(params)})
            .then(res => {
                // 接收后端发送回来的数据
                this.total = res.count;
                this.tableData = res.data;
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 点击树状图节点
        clickTree(data){
            this.currentPage = 1;
            this.ParentId = data.id;
            if (this.showLeve) {
                this.Identify = 0;//把标志改为0.getall
                this.QueryTable(data.id,0);
            }else{
                this.Identify = 1;//把标志改为1.请求search接口
                this.QueryTable(data.id,1);
            }
        },
        // 表格选中行改变时触发，row：当前行数据
        currentChangeEvent(row){
            // console.log(row);
            // this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
            // this.$refs.xTable.scrollToRow( this.$refs.xTable.getCurrentRow());
        },
        // 当前页显示条数发生变化时
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            if (this.Identify==0) {
                this.switchInit(this.showLeve);
            }else{
                this.QueryTable()
            }
            // this.switchInit(this.showLeve);
            this.$refs.key_content.focus();
        },
        // 当前页发生变化时
        handleCurrentChange(val) {
            this.currentPage = val;
            if (this.Identify==0) {
                this.switchInit(this.showLeve);
            }else{
                this.QueryTable()
            }
            // this.switchInit(this.showLeve);
            this.$refs.key_content.focus();
        },
        // 点击上一页时触发函数
        prevPage(){
            // console.log(666)
        },
        // 点击下页时触发函数
        nextPage(){
            // console.log(555)

        },
        // 退出清除数据
        clearData(){
            // 退出前是数据初始化
            this.$emit('update:show', false);
            this.currentPage = 1; //重置当前页码
        },
        // 按上键
        upkey(e){
            if(this.rowIndex!=0){
                this.rowIndex--;
                this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
                this.$refs.xTable.scrollToRow( this.$refs.xTable.getCurrentRow());
            }
        },
        // 按下键
        downkey(e){
            let that = this;
            if(this.tableData&&this.rowIndex+1<this.tableData.length){
                this.rowIndex++;
                that.$refs.xTable.setCurrentRow(that.tableData[that.rowIndex]);
                that.$refs.xTable.scrollToRow( that.$refs.xTable.getCurrentRow());
            }
        },
        // 按回车键
        enterkey(e){
            // 判断当前弹框回车是否有数据，没有数据则
            if(this.tableData.length){
                // 如果是文件夹目录就请求下一层数据
                this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
                let RowData = this.$refs.xTable.getCurrentRow();
                switch (this.searchData.classify) {
                    case 'Client'://客户/供应商
                            this.ParentId = RowData.BtypeId;
                            break;
                        case 'ClientA'://客户
                            this.ParentId = RowData.BtypeId;
                            break;
                        case 'ClientB'://供应商
                            this.ParentId = RowData.BtypeId;
                            break;
                        case 'Stock'://仓库
                            this.ParentId = RowData.KtypeId;
                            break;
                        case 'Person'://经手人
                            this.ParentId = RowData.EtypeId;
                            break;
                        case 'Department'://部门                        
                            this.ParentId = RowData.DeptId;
                            break;
                        case 'Area'://地区
                            this.ParentId = RowData.AreaId;
                            break;
                        case 'Goods'://商品
                            // ParentId = RowData.BtypeId;
                            break;
                        default:
                            break;
                }
                if (RowData.IsDir) {
                    this.currentPage = 1;//重置页码
                    if (this.showLeve) {
                        this.QueryTable(this.ParentId,0);
                    }else{
                        this.QueryTable(this.ParentId,1);
                    }
                }else{//末端数据直接返回结果
                    this.$nextTick(()=>{
                        this.$emit('chooseBack',RowData)
                        this.$emit('update:show', false);
                    })
                }
            }else{
                
            }
        },
    },

    created(){
        // console.log(this.searchData);
        switch (this.searchData.classify) {
           case 'Client'://客户/供应商
                this.tableHeadData = dataConfig.CustomConfig;
                break;
            case 'ClientA'://客户
                this.tableHeadData = dataConfig.CustomConfig;
                break;
            case 'ClientB'://供应商
                this.tableHeadData = dataConfig.CustomConfig;
                break;
            case 'Stock'://仓库
                this.tableHeadData = dataConfig.WarehouseConfig;
                break;
            case 'Person'://经手人
                this.tableHeadData = dataConfig.HandlersConfig;
                break;
            case 'Department'://部门
                this.tableHeadData = dataConfig.DepartmentConfig;
                break;
            case 'Area'://地区
                this.tableHeadData = dataConfig.AreaConfig;
                break;
            case 'Goods'://商品
                this.tableHeadData = dataConfig.CustomConfig;
                break;
            default:
                break;
        }
    },
     // 创建生命周期钩子函数
    mounted() {
        
        // console.log(this.searchData);
        // 初始化数据
        this.InitTree();
        this.switchInit(this.showLeve);
    },
};  
</script>

<style lang="less">
#key_content:focus{
    outline: none;
    border: 0;
    border-color: red;
}
  .el-dialog__header{
      background: rebeccapurple;
      padding: 10px 10px 0;
      .el-dialog__title{
        color: #fff;
        font-size: 14px;
      }
      .el-dialog__headerbtn{
        top: 10px;
        right: 10px;
        .el-dialog__headerbtn .el-dialog__close{
          color: #fff;
        }
      }
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
  .content_box{
    .content_top{
      width: 100%;
      height: 40px;
      display: -webkit-box !important;
      display: box !important;
      position:relative;
      -webkit-box-align:center;
      box-align:center;
      .search_input{
        display: block;
        width: 200px;
      }
    }
    .content_infor_box{
        width: 100%;
        height: 300px;
        display: -webkit-box !important;
        display: box !important;
        position:relative;
        .tree_sty{
            min-width: 200px;
            max-width: 890px;
            height: 300px;
        }
        .drage_box{
            width: 10px;
            height: 100%;
            cursor: e-resize!important;
        }
        .right{
            margin-left: 10px;
            height: 100%;
            position:relative;
            -webkit-box-flex: 1; 
            box-flex: 1;
        }
    }
  }
  .el-tree{
      background: inherit;
  }
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
//   background-color: #a1a3a9;
//   border-radius: 3px;
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #ccc;
}
:-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/Searchpop/Searchpop.vue